// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Navbar$Showside from "../components/Navbar.bs.js";
import * as UseEnv$Showside from "../hook/UseEnv.bs.js";
import * as HotKeys$Showside from "../utils/HotKeys.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as ListPage$Showside from "../pages/ListPage.bs.js";
import * as LCPContext$Showside from "../context/LCPContext.bs.js";
import * as UseAnchors$Showside from "../hook/UseAnchors.bs.js";
import * as DrawerState$Showside from "../context/DrawerState.bs.js";
import * as UseTracking$Showside from "../hook/UseTracking.bs.js";
import * as HistoryUtils$Showside from "../utils/HistoryUtils.bs.js";
import * as AdditionalCSS$Showside from "../components/AdditionalCSS.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as EditorMethods$Showside from "../components/EditorMethods.bs.js";
import * as MadeWithMaker$Showside from "../components/MadeWithMaker.bs.js";
import * as ProfileHeader$Showside from "../components/ProfileHeader.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as UseAddToCart2$Showside from "../hook/UseAddToCart2.bs.js";
import * as LocationConfig$Showside from "../utils/LocationConfig.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as UseContextualL1s$Showside from "../hook/UseContextualL1s.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as CriticalCSSProvider$Showside from "../context/CriticalCSSProvider.bs.js";
import * as EntrypointCallbacks$Showside from "../EntrypointCallbacks.bs.js";
import * as EscapeKeyController$Showside from "../components/EscapeKeyController.bs.js";
import * as MiniCartDrawer_Lazy$Showside from "../components/MiniCartDrawer_Lazy.bs.js";
import * as MkrBioRouterProvider$Showside from "../context/MkrBioRouterProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as QuickViewOverlay_Lazy$Showside from "../pages/QuickViewOverlay_Lazy.bs.js";
import * as InlineContainerContext$Showside from "../context/InlineContainerContext.bs.js";
import * as PictureInPicture2_Lazy$Showside from "../utils/PictureInPicture2_Lazy.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
import * as PictureInPictureContext$Showside from "../utils/PictureInPictureContext.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "../pages/ProductDetailsPage_Lazy.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
import * as UserSavedProductsProvider$Showside from "../context/UserSavedProductsProvider.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/LegacyShowside/LegacyShowside_CategoryDecoders.bs.js";
function InlineApp$MkrBioEscapeKeyControllerWrapper(Props) {
  var children = Props.children;
  var match = RouterProvider$Showside.useRouter(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined).config;
  var categories = match$1.categories;
  var isMkrBioEnabled = match$1.settings.mkrBio !== undefined;
  var match$2 = Belt_Option.getWithDefault(Belt_Array.get(categories, 0), LegacyShowside_CategoryDecoders$ApiTypes.empty);
  var activeCategoryId = Belt_Option.map(RouterProvider$Showside.useActiveCategory(undefined, undefined, categories), function (c) {
    return c.id;
  });
  var isFirstCategory = Caml_obj.equal(match$2.id, activeCategoryId);
  var isTopLevelCategory = Belt_Array.some(categories, function (cat) {
    return Caml_obj.equal(cat.id, activeCategoryId);
  });
  var isListPage;
  var tmp = match.route;
  isListPage = typeof tmp === "number" || tmp.TAG !== /* ListPage */1 ? false : true;
  HotKeys$Showside.use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Escape", function (param) {
    if (isMkrBioEnabled && !isFirstCategory && isTopLevelCategory && isListPage) {
      HistoryUtils$Showside.back(HistoryUtils$Showside.history);
      return;
    }
  });
  return React.createElement(ConditionalRender$Showside.When.make, {
    condition: !isMkrBioEnabled || !isTopLevelCategory || !isListPage,
    children: children
  });
}
InlineApp$MkrBioEscapeKeyControllerWrapper.displayName = "InlineApp.MkrBioEscapeKeyControllerWrapper";
var MkrBioEscapeKeyControllerWrapper = {
  make: InlineApp$MkrBioEscapeKeyControllerWrapper
};
function InlineApp$ContextualInlineRouterWrapper(Props) {
  var embedType = Props.embedType;
  var configId = Props.configId;
  var children = Props.children;
  var contextualRoot = UseContextualL1s$Showside.useContextualRoot(/* Open */2, embedType, window.location.pathname);
  var defaultInitialRoute = Belt_Option.mapWithDefault(contextualRoot, {
    TAG: /* Home */0,
    _0: {
      homeType: /* Index */0,
      filters: undefined,
      sort: undefined
    }
  }, function (root) {
    var isPLP = Category$Showside.isPLP(root);
    var id = root.id;
    return {
      TAG: /* ListPage */1,
      _0: {
        listPageType: {
          TAG: /* Category */0,
          _0: id
        },
        viewPLP: isPLP,
        filters: undefined,
        sort: undefined
      }
    };
  });
  return React.createElement(RouterProvider$Showside.make, {
    configId: configId,
    defaultInitialRoute: defaultInitialRoute,
    embedType: embedType,
    children: children
  });
}
InlineApp$ContextualInlineRouterWrapper.displayName = "InlineApp.ContextualInlineRouterWrapper";
var ContextualInlineRouterWrapper = {
  make: InlineApp$ContextualInlineRouterWrapper
};
function InlineApp$Content(Props) {
  var scrollableContainerRef = Props.scrollableContainerRef;
  var attributes = Props.attributes;
  var embedType = Props.embedType;
  CartContextProvider$Showside.useCart(undefined);
  ViewportContext$Showside.use(undefined);
  var globalScrollRestorationBoundaryRef = React.useRef(null);
  var match = RouterProvider$Showside.useRouter(undefined);
  var quickViewUnderlyingRoute = match.quickViewUnderlyingRoute;
  var route = match.route;
  LocationConfig$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var config = match$1.config;
  var trackEvent = UseTracking$Showside.use(embedType);
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, config.categories);
  React.useEffect(function () {
    Curry.app(trackEvent, ["open", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    if (activeCategory !== undefined) {
      Curry.app(trackEvent, ["top category nav", true, activeCategory, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    } else if (typeof route !== "number" && route.TAG === /* Home */0) {
      Curry.app(trackEvent, ["open index", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
  }, []);
  var anchorHookResult = UseAnchors$Showside.useAnchors(undefined, undefined);
  var tmp = {
    config: config,
    embedType: embedType,
    children: null
  };
  if (attributes !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes);
  }
  var tmp$1;
  var exit = 0;
  var exit$1 = 0;
  var exit$2 = 0;
  if (quickViewUnderlyingRoute !== undefined && !(typeof quickViewUnderlyingRoute === "number" || quickViewUnderlyingRoute.TAG !== /* PDP */2)) {
    exit = 2;
  } else {
    exit$2 = 5;
  }
  if (exit$2 === 5) {
    if (typeof route === "number") {
      exit$1 = 4;
    } else {
      switch (route.TAG | 0) {
        case /* Home */0:
        case /* ListPage */1:
          exit = 3;
          break;
        case /* PDP */2:
          exit = 2;
          break;
        case /* QuickView */3:
          exit$1 = 4;
          break;
      }
    }
  }
  if (exit$1 === 4) {
    if (quickViewUnderlyingRoute !== undefined && typeof quickViewUnderlyingRoute !== "number") {
      switch (quickViewUnderlyingRoute.TAG | 0) {
        case /* Home */0:
        case /* ListPage */1:
          exit = 3;
          break;
        case /* QuickView */3:
          exit = 1;
          break;
      }
    } else {
      exit = 1;
    }
  }
  switch (exit) {
    case 1:
      tmp$1 = React.createElement("div", {
        className: CSS$Showside.prefix("flex-grow")
      });
      break;
    case 2:
      tmp$1 = React.createElement(ProductDetailsPage_Lazy$Showside.make, {});
      break;
    case 3:
      var tmp$2;
      var exit$3 = 0;
      var exit$4 = 0;
      if (quickViewUnderlyingRoute !== undefined) {
        if (typeof quickViewUnderlyingRoute === "number") {
          exit$3 = 4;
        } else {
          switch (quickViewUnderlyingRoute.TAG | 0) {
            case /* PDP */2:
            case /* QuickView */3:
              exit$4 = 5;
              break;
            default:
              exit$3 = 4;
          }
        }
      } else {
        exit$4 = 5;
      }
      if (exit$4 === 5) {
        if (typeof route === "number") {
          exit$3 = 4;
        } else {
          switch (route.TAG | 0) {
            case /* PDP */2:
            case /* QuickView */3:
              tmp$2 = null;
              break;
            default:
              exit$3 = 4;
          }
        }
      }
      if (exit$3 === 4) {
        tmp$2 = React.createElement(Navbar$Showside.make, {
          drawerState: /* Open */2,
          embedType: embedType
        });
      }
      tmp$1 = React.createElement(ListPage$Showside.make, {
        scrollableContainerRef: scrollableContainerRef,
        drawerState: /* Open */2,
        anchorHookResult: anchorHookResult,
        children: tmp$2
      });
      break;
  }
  var tmp$3;
  tmp$3 = typeof route === "number" || route.TAG !== /* QuickView */3 ? null : React.createElement(QuickViewOverlay_Lazy$Showside.make, {});
  return React.createElement(InlineContainerContext$Showside.Provider.make, {
    embedRef: globalScrollRestorationBoundaryRef,
    children: React.createElement(EntrypointCallbacks$Showside.make, tmp, React.createElement(InlineApp$MkrBioEscapeKeyControllerWrapper, {
      children: React.createElement(EscapeKeyController$Showside.make, {
        embedType: embedType
      })
    }), React.createElement(DrawerState$Showside.Provider.make, {
      value: /* Open */2,
      children: null
    }, React.createElement(ConditionalRender$Showside.OptionMap.make, {
      option: config.settings.mkrBio,
      children: function (mkrBio) {
        return React.createElement(ProfileHeader$Showside.make, {
          config: mkrBio
        });
      }
    }), React.createElement(ListPageLayoutController$Showside.make, {
      onChange: function (param) {
        Curry._1(anchorHookResult.setOffset, param.anchorsOffset);
      },
      children: null
    }, React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(globalScrollRestorationBoundaryRef)
    }, tmp$1), tmp$3), React.createElement(ConditionalRender$Showside.OptionMap.make, {
      option: config.transitiveAccount,
      condition: function (account) {
        if (Belt_Option.isSome(config.settings.mkrBio)) {
          return account.showPoweredByMaker;
        } else {
          return false;
        }
      },
      children: function (param) {
        return React.createElement(MadeWithMaker$Showside.make, {});
      }
    }), React.createElement(ConditionalRender$Showside.When.make, {
      condition: config.settings.cart,
      children: React.createElement(MiniCartDrawer_Lazy$Showside.make, {})
    })))
  });
}
InlineApp$Content.displayName = "InlineApp.Content";
var make = React.memo(InlineApp$Content);
var Content = {
  make: make
};
function InlineApp$App(Props) {
  var configId = Props.configId;
  var attributes = Props.attributes;
  var embedType = Props.embedType;
  var entrypointRef = React.useRef(null);
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var isStyleLoaded = CriticalCSSProvider$Showside.useIsStyleLoaded(undefined);
  RouterProvider$Showside.useRouter(undefined);
  var scrollableContainerRef = React.useRef(null);
  var match$1 = UseEnv$Showside.use(undefined);
  var smartnavApiHost = match$1.smartnavApiHost;
  var addToCart = UseAddToCart2$Showside.useAddToCart(configId, smartnavApiHost);
  var pictureInPicture = config.settings.quickviewPictureInPicture;
  var tmp = {
    configId: configId,
    addToCart: addToCart,
    entrypointRef: entrypointRef,
    scrollableContainerRef: scrollableContainerRef,
    smartnavApiHost: smartnavApiHost,
    embedType: embedType
  };
  if (attributes !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes);
  }
  var content = React.createElement(make, tmp);
  var component = React.createElement(StoreProvider$Showside.make, {
    config: config,
    children: React.createElement(LCPContext$Showside.Provider.make, {
      children: React.createElement(ConditionalRender$Showside.When.make, {
        condition: pictureInPicture,
        children: React.createElement(PictureInPictureContext$Showside.make, {
          children: null
        }, content, React.createElement(PictureInPicture2_Lazy$Showside.make, {})),
        fallback: content
      })
    })
  });
  return React.createElement(BaseWithTheme$Showside.make, {
    initiator: "inline",
    portal: false,
    children: null
  }, React.createElement(AdditionalCSS$Showside.make, {
    embedType: embedType
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: isStyleLoaded,
    children: React.createElement("div", {
      ref: ReactDOMUtils$Showside.Ref.domRef(entrypointRef)
    }, component)
  }));
}
InlineApp$App.displayName = "InlineApp.App";
var make$1 = React.memo(InlineApp$App);
var App = {
  make: make$1
};
function InlineApp(Props) {
  var configId = Props.configId;
  var embedType = Props.embedType;
  var attributes = Props.attributes;
  var match = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match.previewMode;
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var config = match$1.config;
  var tmp = {
    configId: configId,
    embedType: embedType
  };
  if (attributes !== undefined) {
    tmp.attributes = Caml_option.valFromOption(attributes);
  }
  var tmp$1 = {
    children: React.createElement(GridDensityZoomProvider$Showside.make, {
      children: React.createElement(make$1, tmp)
    })
  };
  if (attributes !== undefined) {
    tmp$1.attributes = Caml_option.valFromOption(attributes);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(ConditionalRender$Showside.When.make, {
    condition: Caml_obj.notequal(previewMode, /* PreviewLive */1) && previewMode !== undefined,
    children: React.createElement(EditorMethods$Showside.make, {})
  }), React.createElement(UserSavedProductsProvider$Showside.make, {
    configId: config.id,
    accountId: config.accountId,
    historyEnabled: config.settings.historyEnabled,
    favoritesEnabled: config.settings.favoritesEnabled,
    children: React.createElement(InlineApp$ContextualInlineRouterWrapper, {
      embedType: embedType,
      attributes: attributes,
      configId: configId,
      children: React.createElement(MkrBioRouterProvider$Showside.make, {
        attributes: attributes,
        embedType: embedType,
        children: React.createElement(CartContextProvider$Showside.make, {
          children: React.createElement(StickyHeaderOffsetProvider$Showside.make, tmp$1)
        })
      })
    })
  }));
}
InlineApp.displayName = "InlineApp";
var make$2 = InlineApp;
var $$default = InlineApp;
export { MkrBioEscapeKeyControllerWrapper, ContextualInlineRouterWrapper, Content, App, make$2 as make, $$default, $$default as default };
/* make Not a pure module */